function getUniqueEmployees(employeeData) {
  const employeeMap = {};

  employeeData.forEach((employee) => {
    const key = employee.employee_id;

    if (!employeeMap[key]) {
      // If the employee is not in the map, add them with their current data
      employeeMap[key] = {
        ...employee,
        goals: [...employee.goals],
      };
    } else {
      // If the employee is already in the map, merge unique goals
      const existingGoals = employeeMap[key].goals;
      const newGoals = employee.goals.filter(
        (goal) => !existingGoals.some((g) => g.main_goal_id === goal.main_goal_id)
      );
      employeeMap[key].goals.push(...newGoals);
    }
  });

  // Convert the map back to an array of unique employees
  return Object.values(employeeMap);
}

  export default  getUniqueEmployees